export default __webpack_public_path__ + "static/media/wilson.cdb3d88d.jpeg";